import qs from "query-string"
import moment from "moment"
import { replace } from "react-router-redux"
import { GRAPHQL_DATE_FORMAT } from "../helpers/sharedConstants"

// This middleware ensures that the date range is always in the url.
const dateRangeMiddleware = store => next => action => {
  if (
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.search === "" &&
    store.getState().dateRange.startDate &&
    store.getState().router.location
  ) {
    action.payload.search =
      "?" +
      qs.stringify({
        startDate: moment(store.getState().dateRange.startDate).format(
          GRAPHQL_DATE_FORMAT
        ),
        endDate: moment(store.getState().dateRange.endDate).format(
          GRAPHQL_DATE_FORMAT
        ),
      })
    store.dispatch(replace(action.payload))
  } else {
    next(action)
  }
}

export default dateRangeMiddleware
